// extracted by mini-css-extract-plugin
export default {"btn":"CTAButton_btn__K5-z4","primary":"CTAButton_primary__iVj1E","outline":"CTAButton_outline__iFWgx","icon":"CTAButton_icon__R0nU3","arrow":"CTAButton_arrow__BVXTA"};